import { ANALYTICS_EVENTS_COOKIE } from "./types";

export type { AnalyticsEvent } from "./types";

/**
 * Read all pending analytics events from cookie (client-side)
 */
export function readPendingAnalyticsEvents(): Array<{
  event: string;
  params?: Record<string, string | number>;
}> {
  if (typeof document === "undefined") {
    return [];
  }

  const cookies = document.cookie.split("; ");
  const eventsCookie = cookies.find((c) =>
    c.startsWith(`${ANALYTICS_EVENTS_COOKIE}=`),
  );

  if (!eventsCookie) {
    return [];
  }

  try {
    const value = eventsCookie.split("=")[1];
    const events = JSON.parse(decodeURIComponent(value));
    return Array.isArray(events) ? events : [];
  } catch (error) {
    console.error("Failed to parse pending analytics events", error);
    return [];
  }
}

/**
 * Clear all pending analytics events cookie (client-side)
 */
export function clearPendingAnalyticsEvents(): void {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${ANALYTICS_EVENTS_COOKIE}=; Max-Age=0; path=/`;
}
